export default "__VITE_ASSET__BsqjB1oY__"